import { removeNonDigitCharacters } from 'utils/helpers';
import { forEach, keys } from 'lodash';
import { fieldNames } from '../const';

const followupErrors = {
  fieldRequired: 'followup.errors.fieldRequired',
  numericLimit: 'followup.errors.numericFieldLimit',
  textLimit: 'followup.errors.textFieldLimit',
};

export default function followUpValidation(values, form) {
  const errors = {};
  const normalizeNumber = (value) => Number(removeNonDigitCharacters(value));
  const valuesKeys = keys(values);
  const registeredFieldsKeys = keys(form.registeredFields);


  // general validation
  if (valuesKeys.length === 0) {
    // validate all fields when user trying to submit empty form
    forEach(registeredFieldsKeys, (field) => {
      errors[field] = followupErrors.fieldRequired;
    });
  } else {
    forEach(registeredFieldsKeys, (field) => {
      // validate if required and some fields got value
      if (!valuesKeys.includes(field)) {
        errors[field] = followupErrors.fieldRequired;
      }
    });
  }

  // specific validations
  const handleNumericFieldValidation = (value, fieldName, min, max) => {
    if (value < min || value > max) {
      errors[fieldName] = followupErrors.numericLimit;
    }
  };

  const handleTextFieldValidation = (value) => value.length > 255;

  const handleExtraFieldValidation = (value, mandatoryOption, clarificationFieldName) => {
    if (value === mandatoryOption) {
      if (!values[clarificationFieldName]) {
        errors[clarificationFieldName] = followupErrors.fieldRequired;
      } else if (handleTextFieldValidation(values[clarificationFieldName])) {
        errors[clarificationFieldName] = followupErrors.textLimit;
      }
    }
  };

  forEach(valuesKeys, (fieldName) => {
    // static fields validation
    switch (fieldName) {
      case fieldNames.alternativeIncomeAmount:
        return handleNumericFieldValidation(
          normalizeNumber(values.alternativeIncomeAmount),
          fieldName,
          0,
          30000
        );
      case fieldNames.governmentBenefits:
        return handleExtraFieldValidation(
          values.governmentBenefits,
          'NO',
          fieldNames.governmentBenefitsClarification
        );
      case fieldNames.essentialNeeds:
        return handleExtraFieldValidation(
          values.essentialNeeds,
          'OTHER',
          fieldNames.essentialNeedsClarification
        );
      case fieldNames.ongoingTransfers:
        return handleExtraFieldValidation(
          values.ongoingTransfersExtraPart,
          'OTHER',
          fieldNames.ongoingTransfersExtraPartClarification
        );
      case fieldNames.housingExpenses:
        return handleExtraFieldValidation(
          values.housingExpenses,
          'OTHER',
          fieldNames.housingExpensesClarification
        );
      case fieldNames.otherExpensesClarification:
        if (handleTextFieldValidation(values.otherExpensesClarification)) {
          errors[fieldNames.otherExpensesClarification] = followupErrors.textLimit;
        }
        break;
      default:
        break;
    }

    //  dynamic fields validation
    if (fieldName.includes('unsureLenderAmount')) {
      return handleNumericFieldValidation(
        normalizeNumber(values[fieldName]),
        fieldName,
        0,
        10000
      );
    }

    if (fieldName.includes(fieldNames.ongoingTransferExtraPartAmount)) {
      return handleNumericFieldValidation(
        normalizeNumber(values[fieldName]),
        fieldName,
        0,
        10000
      );
    }

    if (fieldName.includes(fieldNames.ongoingTransfersExtraPartClarification)) {
      if (handleTextFieldValidation(values[fieldName])) {
        errors[fieldName] = followupErrors.textLimit;
      }
    }

    if (fieldName.includes(fieldNames.creditEnquiryAmount)) {
      return handleNumericFieldValidation(
        normalizeNumber(values[fieldName]),
        fieldName,
        0,
        10000
      );
    }

    return null;
  });

  return errors;
}
